<ng-container
  *ngIf="{
    ordersRequest: ordersRequest$ | async,
  } as content"
>
  @if (content.ordersRequest.length) {
    <div class="row m-tb-20">
      <div class="col-6">
        <h2 style="color: var(--cx-color-primary)">Recent Orders</h2>
      </div>
      <div class="col-6" style="display: flex; justify-content: flex-end">
        <a [routerLink]="['/my-account/orders']" class="btn btn-secondary-1">
          View All
        </a>
      </div>
    </div>

    <table class="table-responsive table-md m-tb-20">
      <thead>
      <tr>
        <th>Order/PO #</th>
        <th>Order Date</th>
        <th>Status</th>
        <th>Total</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let order of content.ordersRequest">
        <td [attr.data-value]="order.code">
          <div>
            <span class="responsive-title m-r-4">Order/PO #:</span>
            <a [routerLink]="['/my-account/order', order.uid]" class="text-underline">
              {{ order.code }}
            </a>
            <br>
            <span>{{ order.purchaseOrderNumber }}</span>
          </div>
        </td>

        <td [attr.data-value]="order.created">
          <span class="responsive-title"> Order Date:</span>

          {{ order.created | date: 'MM/dd/yyyy' }}
        </td>

        <td [attr.data-value]="order.statusDisplay">
          <span class="responsive-title"> Status:</span>
          {{ order.statusDisplay }}
        </td>

        <td [attr.data-value]="order.totalPrice?.value">
          <span class="responsive-title"> Total:</span>
          {{ order.totalPrice?.formattedValue }}
        </td>
      </tr>
      </tbody>
    </table>
 }
</ng-container>
